<template>
  <footer class="footer">
    <nav class="navbar navbar-expand navbar-dark">
      <div class="container">
        <div class="row w-100">
          <div class="col-sm-2">
            <router-link
              active-class="active"
              @click.native="collapseMenu"
              class="nav-link"
              to="/">
              <img src="~assets/img/logo.png">
            </router-link>
          </div>
          <div class="col-sm-10">
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
              <ul class="ml-auto mt-4 mt-md-0 navbar-nav">
                <li class="nav-item mr-3">
                  <router-link class="nav-link" to="/about">Sobre</router-link>
                </li>
                <li class="nav-item mr-3">
                  <router-link class="nav-link" to="/faq">FAQ</router-link>
                </li>
                <li class="nav-item mr-3">
                  <a class="nav-link" href="https://forms.gle/2XeYcZQPLE5muko87" target ="_blank">Contato</a>
                </li>
                <li class="nav-item mr-3">
                  <router-link class="nav-link" to="/terms">Termos de uso e Politica de Privacidade</router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </nav>
  </footer>
</template>

<script>
export default {
  name: "page-footer"
};
</script>

<style lang="scss" scoped>
@import "~assets/scss/globals.scss";
.footer {
  padding-bottom: 46px;
  padding-top: 46px;
  background: #006eb8;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
}
.navbar {
  background: #006eb8;
}
.navbar-dark {
  .navbar-nav {
    @media (max-width: 480px) {
      flex-wrap: wrap;

      .nav-item {
        width: 100%;
      }
    }
    .nav-link {
      @include font-size(16);
      color: #f2f2f2;
    }
  }
}
</style>




// WEBPACK FOOTER //
// PageFooter.vue?d4309a08